import { Button, formUtils, Modal } from '@insurancemenu/imenu-components-lib';
import React from 'react';
import FormsSpinner from 'components/common/loaders/FormSpinner';
import { FormObjectFromJSON } from '@insurancemenu/imenu-components-lib/dist/types';
import { observer } from 'mobx-react-lite';
import clsx from 'clsx';
import { WEB_FORM_CUSTOM_COMPONENTS } from 'components/common/form/custom/FormCustomComponents';
import { createStyles } from './styles';

interface Props {
  show: boolean;
  closable?: boolean;
  onClose: () => void;
  onAction: (e: React.FormEvent) => void;
  dynamicForm: null | formUtils.DynamicFormController;
  form: FormObjectFromJSON;
  loading: boolean;
  footerCancelButton?: JSX.Element;
  footerSubmitButton?: JSX.Element;
  submitButtonText?: string;
  isEditable?: boolean;
  modalMaxWidth?: string;
  formStyles?: string;
  className?: string;
  'data-test-id'?: string;
}

/** @deprecated Use DynamicFormModal from the library instead */
// eslint-disable-next-line camelcase
const DynamicFormModalDEPRECATED = observer(
  ({
    show,
    closable = true,
    onClose,
    onAction,
    loading,
    dynamicForm,
    form,
    footerCancelButton,
    footerSubmitButton,
    submitButtonText = '',
    isEditable = true,
    modalMaxWidth = '',
    formStyles,
    'data-test-id': dataTestId,
    className,
  }: Props): JSX.Element => {
    const classes = createStyles({ modalMaxWidth });
    return (
      <Modal
        show={show}
        onClose={onClose}
        closable={closable}
        className={clsx(classes.modal, className)}
        data-test-id={dataTestId}
      >
        {loading ? (
          <FormsSpinner display={loading} />
        ) : (
          <>
            <h3 className={classes.title}>{form?.formTitle || ''}</h3>
            <form onSubmit={onAction} className={clsx(classes.form, formStyles, !isEditable && classes.disableForm)}>
              <div>{dynamicForm && formUtils.renderSections(form, dynamicForm, WEB_FORM_CUSTOM_COMPONENTS)}</div>
            </form>
            <footer className={classes.modalFooter}>
              {footerCancelButton || (
                <Button type="outlined" onClick={onClose} size="large" className={classes.button}>
                  {isEditable ? 'Cancel' : 'Exit'}
                </Button>
              )}
              {isEditable &&
                (footerSubmitButton || (
                  <Button
                    disabled={!dynamicForm?.basicFieldsValidationsPassed}
                    color="primary"
                    onClick={onAction}
                    size="large"
                    className={classes.button}
                    htmlType="submit"
                  >
                    {submitButtonText || 'Save'}
                  </Button>
                ))}
            </footer>
          </>
        )}
      </Modal>
    );
  },
);

export default DynamicFormModalDEPRECATED;
